
import React, { Fragment } from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

const DEFAULT_RELEASE_STAGES = ['development', 'uat', 'production']

/**
 * Bugsnag react documentation:
 *   https://docs.bugsnag.com/platforms/javascript/legacy/react/#basic-configuration
 *
 * This util is just a wrapper of bugsnag
 */
const BugsnagUtil = {
  initialize: ({
    apiKey,
    appVersion,
    releaseStage = DEFAULT_RELEASE_STAGES[0],
    enabledReleaseStages = DEFAULT_RELEASE_STAGES
  }) => {
    if (enabledReleaseStages.indexOf(releaseStage) > -1) {
      Bugsnag.start({
        appVersion,
        apiKey,
        plugins: [new BugsnagPluginReact()],
        releaseStage,
        enabledReleaseStages
      })
    }
  },
  getErrorBoundary: (react = React) => {
    const { _client } = Bugsnag
    if (_client) {
      return Bugsnag.getPlugin('react').createErrorBoundary(react)
    }

    return Fragment
  },
  notify: (error) => {
    const { _client } = Bugsnag

    if (_client) {
      Bugsnag.notify(error)
    }
  }
}

export default BugsnagUtil
